import { render, staticRenderFns } from "./CreateRestaurantModal.vue?vue&type=template&id=5a92aedd"
import script from "./CreateRestaurantModal.vue?vue&type=script&lang=js"
export * from "./CreateRestaurantModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports